interface GlobalsisBillingConfig {
  id: number;
  fiscalIdentificationNumber: number;
  puntoVentaNumber: string;
  socialReason: string;
  username: string;
  encryptedPassword: string;
}

interface Commerce {
  id: string;
  allowBilling: boolean;
  globalsisBillingConfig: GlobalsisBillingConfig | null;
}

export enum OrderStatusEnum {
  Created = 1,
  Incompleted = 7
}

export interface OrderDetailItem {
  id: string;
  productName: string;
  quantity: number;
  price: number;
}

export default interface Order {
  id: number;
  commerce: Commerce;
  orderDetail: OrderDetailItem[];
  statusId: number;
  createdAt: Date;
  totalAmount: number;
  invoiceProcessId: string | null;
  invoiceEmail: string | null;
}
